module.exports = __webpack_public_path__ + "static/media/national-procurement-awards-img.d3328876.png";